import React from 'react';
import { Button, Modal } from 'react-bootstrap';

function ModalCustom({ show, voc, onClose, onSubmit, closeModal }) {
    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop="static"
        keyboard={false}
        aria-labelledby={`contained-modal-title-${voc.href}`}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id={`contained-modal-title-${voc.href}`}>
            Adicionar Golo!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {voc.autogolo === 'Y' ?
            <>
                Adicionar autogolo para <strong>{voc.nomeequipa}</strong>?
            </>
                : 
                <>Adicionar golo para <strong>{voc.nomeequipa}</strong>, marcado por <strong>{voc.nomejogador}</strong>?</>
            }
            </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={() => closeModal(voc)} >Cancelar</Button>
            <Button variant="primary" onClick={() => onSubmit(voc)}  >OK</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  export default ModalCustom